/* eslint-disable no-console */
import { takeLatest, call, put, select } from 'redux-saga/effects';

// Connected React Router
import { push } from 'connected-react-router';

// Services
import { integrationFenceApi } from 'services/apiDigitalTicket/integrationFence';

// Actions
import * as DialogsActions from 'store/ducks/dialogs/actions';
import * as SnackbarsActions from 'store/ducks/snackbars/actions';

// Constants
import { errorMessagersList } from 'helpers/errorMessagers';
import PATH from 'constants/basePath';

// Actions
import * as IntegrationFenceActions from './actions';

// Types
import { IntegrationFenceTypes } from './types';

function* list({
  payload,
}: ReturnType<
  typeof IntegrationFenceActions.listIntegrationFenceRequest
>): any {
  try {
    const { body } = payload;

    yield put(DialogsActions.setOpenLoading({ title: 'Carregando cercas' }));

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(integrationFenceApi.get, {
      params: { transportOperatorId: transportOperator.id, ...body },
    });

    if (response.status === 200) {
      yield put(
        IntegrationFenceActions.listIntegrationFenceSuccess({
          integrationFenceList: response.data,
          totalCount: parseInt(response.headers.totalcount, 10),
        }),
      );

      yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('integrationFence - listIntegrationFence - error', error);

    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );

    yield put(IntegrationFenceActions.listIntegrationFenceFailure());

    yield put(DialogsActions.setClose());
  }
}

function* get({
  payload,
}: ReturnType<typeof IntegrationFenceActions.getIntegrationFenceRequest>): any {
  try {
    yield put(DialogsActions.setOpenLoading({ title: 'Carregando dados' }));

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(integrationFenceApi.get, {
      params: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(
        IntegrationFenceActions.getIntegrationFenceSuccess({
          integrationFenceData: response.data,
        }),
      );
      yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('integrationFence - getIntegrationFence - error', error);

    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );

    yield put(IntegrationFenceActions.getIntegrationFenceFailure());
    yield put(DialogsActions.setClose());
  }
}

function* create({
  payload,
}: ReturnType<
  typeof IntegrationFenceActions.createIntegrationFenceRequest
>): any {
  try {
    yield put(DialogsActions.setOpenLoading({ title: 'Criando cerca' }));

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(integrationFenceApi.create, {
      data: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(
        IntegrationFenceActions.createIntegrationFenceSuccess({
          integrationFenceData: response.data,
        }),
      );
      yield put(DialogsActions.setClose());

      yield put(
        SnackbarsActions.setOpen({
          open: true,
          type: 'success',
          message: 'Cerca criado com sucesso',
        }),
      );

      yield put(push(PATH.INTEGRATION_FENCE.BASE_URL));
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('integrationFence - createIntegrationFence - error', error);

    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );

    yield put(IntegrationFenceActions.createIntegrationFenceFailure());
    yield put(DialogsActions.setClose());
  }
}

function* update({
  payload,
}: ReturnType<
  typeof IntegrationFenceActions.updateIntegrationFenceRequest
>): any {
  try {
    yield put(DialogsActions.setOpenLoading({ title: 'Editando dados' }));

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(integrationFenceApi.update, {
      data: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      if (response.data) {
        yield put(
          IntegrationFenceActions.updateIntegrationFenceSuccess({
            integrationFenceData: response.data,
          }),
        );
        yield put(DialogsActions.setClose());
      }

      yield put(
        SnackbarsActions.setOpen({
          open: true,
          type: 'success',
          message: 'Cerca alterada com sucesso',
        }),
      );

      yield put(push(PATH.INTEGRATION_FENCE.BASE_URL));
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('integrationFence - updateIntegration - error', error);

    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );

    yield put(IntegrationFenceActions.updateIntegrationFenceFailure());
    yield put(DialogsActions.setClose());
  }
}

function* remove({
  payload,
}: ReturnType<
  typeof IntegrationFenceActions.deleteIntegrationFenceRequest
>): any {
  try {
    yield put(DialogsActions.setOpenLoading({ title: 'Excluindo cerca' }));

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(integrationFenceApi.delete, {
      params: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(
        SnackbarsActions.setOpen({
          open: true,
          type: 'success',
          message: 'Cerca excluída com sucesso',
        }),
      );

      yield put(DialogsActions.setClose());

      if (window.location.pathname === PATH.INTEGRATION_FENCE.BASE_URL) {
        yield put(IntegrationFenceActions.listIntegrationFenceRequest({}));
        return;
      }

      yield put(push(PATH.INTEGRATION_FENCE.BASE_URL));
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('integrationFence - removeIntegrationFence - error', error);

    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );

    yield put(IntegrationFenceActions.deleteIntegrationFenceFailure());
    yield put(DialogsActions.setClose());
  }
}

// eslint-disable-next-line import/prefer-default-export
export const integrationFenceSagas = [
  takeLatest(IntegrationFenceTypes.LIST_INTEGRATION_FENCES_REQUEST, list),
  takeLatest(IntegrationFenceTypes.GET_INTEGRATION_FENCE_REQUEST, get),
  takeLatest(IntegrationFenceTypes.CREATE_INTEGRATION_FENCE_REQUEST, create),
  takeLatest(IntegrationFenceTypes.UPDATE_INTEGRATION_FENCE_REQUEST, update),
  takeLatest(IntegrationFenceTypes.DELETE_INTEGRATION_FENCE_REQUEST, remove),
];
